import type { IconData } from '@stacksjs/iconify-core'

export const keyholeLockCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 4.5C13.23 4.5 4.5 13.23 4.5 24S13.23 43.5 24 43.5S43.5 34.77 43.5 24S34.77 4.5 24 4.5M.5 24C.5 11.021 11.021.5 24 .5S47.5 11.021 47.5 24S36.979 47.5 24 47.5S.5 36.979.5 24M24 11.773a7.34 7.34 0 0 0-4 13.498l-1.945 7.902c-.29 1.174.34 2.436 1.62 2.682c2.811.54 5.839.54 8.65 0c1.28-.246 1.91-1.508 1.62-2.682L28 25.27a7.341 7.341 0 0 0-4-13.497\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default keyholeLockCircleRemix
